import React from "react";
import { createSvgIcon } from "../create-svg-icon";

export const SignalCellular3BarIcon = createSvgIcon(
  <React.Fragment>
    <path fillOpacity=".3" d="M2 22h20V2L2 22z" />
    <path d="M17 7L2 22h15V7z" />
  </React.Fragment>,
  "SignalCellular3BarOutlined"
);
